import { ShopOutlined } from '@ant-design/icons';
import type { NavigationItemType } from '~/types/navigation';

export default {
    id: 'webshop',
    permission: 'webshop.list',
    title: 'Webshopovi',
    icon: ShopOutlined,
    type: 'item',
    url: '/webshops',
} satisfies NavigationItemType;
